// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dc2db6be","337":"1e33d577","453":"eae8a44e","455":"5a6acff2"}[chunkId] + ".chunk.js";
};